/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import CustomTable from '../../../../../components/table/CustomTable';
import MainVehiclesTableApp from "../Functionality/MainVehiclesTableApp";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {getViewTypeByName} from "../../../../../enums/ViewType";
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import { permissionObj } from '../../../../../Helpers/permission';
import routes from '../../../../../Routes/routes';

const MainVehiclesTable = ({
    view,
    selectedList,
    setSelectedList,
    option,
    bodyForExport,
    setBodyForExport,
    setSearch,
    setSimpleSearch,
    searchElement,
    setSearchElement,
    finalArray,
    isAllChecked,
    setIsAllChecked,
    setCriteria,
    modified,
    setModified,
    showActionsContractorSupplier
}) => {
    const {
        contractorId,
        supplierId,
        tableId,
        searchId,
        thead,
        tbody,
        setResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        deletePermission,
        DEV,
        permission,
        navigate,
        t,
        showColumnsButtons
    } = MainVehiclesTableApp({
        view,
        selectedList,
        setSelectedList,
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        setIsAllChecked,
        setCriteria,
        modified,
        setModified,
        showActionsContractorSupplier
    });

    return (
        <>
            <SearchSimple
                id={"txt_av_search_simple"}
                setBodyForExport={setBodyForExport}
                bodyForExport={bodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                viewType={getViewTypeByName(view)}
            />

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={showColumnsButtons}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={
                    tbody?.data?.length === 0 ? (
                        <>
                            <div className={'warning-text'}>
                                <p>{t('you_have_not_created_any_vehicles_yet')}</p>
                            </div>
                            {(contractorId ||
                                supplierId ||
                                DEV ||
                                permission?.includes(permissionObj?.WEB_VEHICLE_CREATE)) && (
                                <CustomButtonLink
                                    splitName={false}
                                    id={'btn_mvt_create'}
                                    card={true}
                                    onClick={() =>
                                        navigate(
                                            supplierId
                                                ? routes.vehicleSupplier.create
                                                : contractorId
                                                  ? routes.vehicleContractor.create
                                                  : routes.vehicleFleet.create,
                                        )
                                    }
                                    name={'create_new_vehicle'}
                                />
                            )}
                        </>
                    ) : undefined
                }
            />
            {pagination()}
        </>
    );
};

export default MainVehiclesTable;
